// biome-ignore lint/style/noRestrictedImports: component usage
import { Trigger as RadixTooltipTrigger } from "@radix-ui/react-tooltip";
import { Slot } from "@suse-o11y/slot";
import React from "react";

import { useIsTooltipHidden } from "./_context";
import { enable, useIsEnabled } from "./_enabler";

export type TooltipTriggerProps = React.ComponentProps<typeof RadixTooltipTrigger>;

export const TooltipTrigger = React.forwardRef<React.ComponentRef<typeof RadixTooltipTrigger>, TooltipTriggerProps>(
	({ asChild = true, ...props }, ref) => {
		const Root = asChild ? Slot : "button";
		const hidden = useIsTooltipHidden();
		const isEnabled = useIsEnabled();

		if (hidden) {
			return <Root ref={ref} {...props} />;
		}

		if (isEnabled) {
			return <RadixTooltipTrigger asChild={asChild} ref={ref} {...props} />;
		}

		return (
			<Root
				ref={ref}
				{...props}
				onFocus={(event) => {
					enable();
					props.onFocus?.(event);
				}}
				onMouseEnter={(event) => {
					enable();
					props.onMouseEnter?.(event);
				}}
			/>
		);
	},
);

if (import.meta.env.DEV) {
	TooltipTrigger.displayName = "TooltipTrigger";
}
